import { MasterDialog } from "#common/Dialog/Dialog"
import CircularSkeleton from "#common/skeleton/CircularSkeleton"
import { COLOR_PRIMARY, COLOR_WHITE } from "#constants/Styles"
import ErrorResponse from "#core/pages/ErrorResponse"
import { useApi } from "#hooks/useApi"
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth"
import { Box, Typography } from "@mui/material"
import Avatar from "@mui/material/Avatar"
import Divider from "@mui/material/Divider"
import List from "@mui/material/List"
import ListItem from "@mui/material/ListItem"
import ListItemAvatar from "@mui/material/ListItemAvatar"
import ListItemText from "@mui/material/ListItemText"
import * as React from "react"
import { Fragment, useMemo } from "react"

export default function MainDetailsHistoryDialog({
	apiCall,
	params,
	open,
	setOpen,
	profileData,
	bgcolor,
	listItems = [],
}) {
	const buttons = useMemo(
		() => [
			{
				label: "Cerrar",
				onClick: () => {
					setOpen(false)
				},
			},
		],
		[setOpen]
	)

	return (
		<Fragment>
			<MasterDialog
				{...{
					open,
					setOpen,
					title: "Historial",
					buttons,
					maxWidth: "md",
				}}
			>
				<MainDetailsHistory
					apiCall={apiCall}
					params={params}
					autoFetch={open}
					profileData={profileData}
					listItems={listItems}
					bgcolor={bgcolor}
				/>
			</MasterDialog>
		</Fragment>
	)
}
export function MainDetailsHistory({
	apiCall,
	params,
	autoFetch,
	bgcolor,
	listItems = [],
}) {
	const { data, loading, error } = useApi(apiCall, {
		autoFetch,
		params,
	})
	const history = data?.data || []

	if (loading) return <CircularSkeleton />
	if (error) return <ErrorResponse api={error} />

	if (history.length === 0)
		return (
			<Box
				sx={{ display: "flex", flexDirection: "column", gap: 2, alignItems: "center" }}
			>
				<Typography variant="h5">No hay historial</Typography>
			</Box>
		)

	return history.map((item, index) => {
		const action = item.action.toLowerCase()
		return (
			<>
				<List sx={{ width: "100%", bgcolor: "background.paper" }}>
					<ListItem alignItems="flex-start">
						<ListItemAvatar>
							<Avatar
								sx={{
									bgcolor: bgcolor ? bgcolor(action) : COLOR_PRIMARY,
									color: COLOR_WHITE,
								}}
							>
								<IconHistory clave={action} listItems={listItems} />
							</Avatar>
						</ListItemAvatar>
						<ListItemText
							primary={item.created_by_name}
							secondary={
								<React.Fragment>
									<Typography
										sx={{ display: "inline" }}
										component="span"
										variant="body2"
										color="text.primary"
									>
										{item.created_at}
									</Typography>
									<br />
									{item.description}
								</React.Fragment>
							}
						/>
					</ListItem>
					{index !== history.length - 1 && <Divider variant="inset" component="li" />}
				</List>
			</>
		)
	})
}

const IconHistory = ({ clave, listItems = [] }) => {
	let icon = <CalendarMonthIcon />
	listItems.forEach((item) => {
		if (clave.includes(item.key.toLowerCase())) icon = item.icon
	})
	return icon
}

// const items = [
// 	{
// 		icon: <AssignmentIndIcon />,
// 		key: "Creacion",
// 	},
// 	{
// 		icon: <AssignmentIndIcon />,
// 		key: "Creado",
// 	},
// 	{
// 		icon: <SyncIcon />,

// 		key: "Actualizado",
// 	},
// 	{
// 		icon: <WorkIcon />,
// 		key: "Activado",
// 	},
// 	{
// 		icon: <WorkOffIcon />,
// 		key: "Desactivado",
// 	},
// 	{
// 		icon: <WorkspacePremiumIcon />,
// 		key: "competencia",
// 	},
// 	{
// 		icon: <EmojiPeopleIcon />,
// 		key: "interacción",
// 	},
// 	{
// 		icon: <DownhillSkiingIcon />,
// 		key: "skill",
// 	},
// 	{
// 		icon: <AdminPanelSettingsIcon />,
// 		key: "responsabilidad",
// 	},
// 	{
// 		icon: <HandymanIcon />,
// 		key: "herramienta",
// 	},
// 	{
// 		icon: <PsychologyIcon />,
// 		key: "kpi",
// 	},
// ]
